import { programs } from '@/utils/constants';
import { getApiMethod } from '@/modules/apiSelector';

export default {
  namespaced: true,
  state: {
    videoId: null,
    videoType: null,
    videoLabel: null,
    videoUrl: null,
    showVideo: true,
    isVideoReady: true,
    activate: false,
    videoLog: null
  },

  mutations: {
    setVideoLesson(state, payload) {
      state.videoId = payload.videoId;
      state.videoType = payload.videoType;
      state.videoLabel = payload.videoLabel;
      state.videoUrl = payload.videoUrl;
    },
    setShowVideo(state, payload) {
      state.showVideo = payload;
    },
    setVideoReady(state, payload) {
      state.isVideoReady = payload;
    },
    setToDefault(state, payload) {
      state.videoId = payload.videoId;
      state.videoType = payload.videoType;
    },
    setActivate(state, payload) {
      state.activate = payload;
    },
    setVideoLog(state, payload) {
      state.videoLog = payload;
    }
  },

  actions: {
    toggleVideoLesson({ commit, rootGetters }, toogle) {
      if (rootGetters.isToEnableVideoLesson) {
        commit('setShowVideo', toogle);
      }
    },
    resetVideoSetting({ commit }) {
      commit('setVideoLesson', {
        videoId: null,
        videoType: null,
        videoLabel: null,
        videoUrl: null
      })
      commit('setShowVideo', false);
    },
    async fetchVideo({ rootState }, currentMaterial) {
      if (window && window.player) {
        // If player exists, pause video
        window.player.accessor.pause();
      }
      let rank;
      let lessonNo = rootState.material.currentLesson + 1;

      switch (rootState.programId) {
        case programs.other:
          rank = rootState.lessonBookRank;
          break;
        default:
          if (rootState.material.currentRanks.ri) {
            rank = rootState.material.currentRanks.ri;
          } else {
            rank = (rootState.studentRank - rootState.material.rankTotal + 1) + rootState.material.currentRank;
          }
      }

      const params = {
        b: rootState.lessonId,
        ln: lessonNo,
        li: currentMaterial.li,
        r: rank
      }

      const apiMethod = getApiMethod('getVideoData');
      await apiMethod(params);
    }
  }
}
